import { featureToggle } from "@faire/web--source/common/settings/declarations/featureToggle";

/**
 * Controls whether serialized insider membership information is enabled.
 */
export const FE_PHASE_OUT_SERIALIZED_INSIDER_MEMBERSHIP_INFORMATION_250224 =
  featureToggle({
    name: "FE_PHASE_OUT_SERIALIZED_INSIDER_MEMBERSHIP_INFORMATION_250224",
    identifier: "RetailerTokenInSession",
    client: "RETAILER",
    notifyAfter: "2025-04-25",
    productArea: "INSIDER",
  });
